import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru'
import {CoreModule} from './core/core.module';
import {environment} from '../environments/environment';
import {DashboardState} from './dashboard/state/dashboard.state';
import {NgxsReduxDevtoolsPluginModule} from '@ngxs/devtools-plugin';
import {NgxsModule} from '@ngxs/store';
import {HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule, HttpXsrfTokenExtractor} from '@angular/common/http';
import {MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule} from '@angular/material/snack-bar';
import {ErrorInterceptor} from './error-interceptor';
import {SharedModule} from './shared/shared.module';
import {TokenInterceptor} from './token.interceptor';
import {MatSelectModule} from '@angular/material/select';
import {MatChipsModule} from '@angular/material/chips';
import {CoreState} from './core/state/core.state';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTableModule} from '@angular/material/table';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER} from "@angular/material/autocomplete";
import {ReportsState} from "./reports/state/reports.state";
import {HistoryState} from "./history/state/history.state";
import {SelectionsState} from "./selections/state/selections.state";
import {MomentModule} from 'ngx-moment';
import {HelpState} from "./help/state/help.state";
import {HomeState} from "./home/state/home.state";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {UniversityState} from "./university/state/university.state";
import {MAT_DATE_LOCALE} from "@angular/material/core";
import {TutorialComponent} from "./tutorial/tutorial.component";

registerLocaleData(localeRu, 'ru');

@NgModule({
  declarations: [
    AppComponent,
    TutorialComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    CoreModule,
    MatSelectModule,
    MatChipsModule,
    MatSnackBarModule,
    HttpClientXsrfModule,
    MatMenuModule,
    MatTooltipModule,
    MatDialogModule,
    MatTableModule,
    ScrollingModule,
    MomentModule,
    SharedModule,
    NgxsModule.forRoot([
      CoreState,
      DashboardState,
      ReportsState,
      HistoryState,
      SelectionsState,
      UniversityState,
      HelpState,
      HomeState,
    ], {developmentMode: !environment.production}),
    environment.production ? [] : NgxsReduxDevtoolsPluginModule.forRoot(),
  ],
  exports: [
    DragDropModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'ru' },
    { provide: MAT_DATE_LOCALE, useValue: 'ru-RU' },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 2500,
        panelClass: 'mosuir-toast',
        verticalPosition: 'bottom',
        horizontalPosition: 'right'
      }
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY_PROVIDER,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
